// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table_header {
  --i: 0;
}
.table_header:before {
  content: "";
  position: absolute;
  z-index: -1;
  width: var(--width);
  top: 1px;
  left: var(--left);
  height: 100%;
  border-radius: 8px;
  opacity: 0.2;
  background: var(--background);
  transition: 0.3s ease-in-out;
  filter: contrast(0.4);
}
@media only screen and (max-width: 1199px) {
  .table_header:before {
    height: calc(100% - 1.5rem);
  }
}
.table_header .header {
  margin-inline: 10px;
  padding-inline: 10px;
  padding-block: 0.2rem;
  transition: 0.2s ease-in-out;
}
.table_header .header:not(:first-child):after {
  content: "";
  display: block;
  width: 2px;
  height: 15px;
  background-color: var(--surface-100);
  position: absolute;
  left: -10px;
  top: 50%;
  translate: 0 -50%;
}

.header_count {
  width: 20px;
  height: 20px;
  font-size: 12px;
  color: var(--surface-900);
}
.header:first-child .header_count {
  color: black;
}

.table_content {
  grid-template-columns: repeat(4, 1fr);
}
@media only screen and (max-width: 1199px) {
  .table_content {
    grid-template-columns: repeat(2, 1fr);
  }
}
.table_content .app {
  border: 1px solid var(--surface-100);
  box-shadow: 0px 0px 8px 1px var(--background);
}
@media only screen and (max-width: 1199px) {
  .table_content .app {
    height: 100%;
  }
}
.table_content .image-container {
  height: 32px;
}
.table_content .app_header > *:last-child {
  padding-left: 10px;
}
.table_content .app_header > *:last-child:before {
  content: "";
  display: block;
  width: 2px;
  height: 15px;
  background-color: var(--surface-100);
  position: absolute;
  left: -10px;
  top: 50%;
  translate: 0 -50%;
}
@media only screen and (max-width: 1199px) {
  .table_content .app_header > *:last-child:before {
    width: 15px;
    height: 2px;
    top: 0px;
    left: 50%;
    translate: -50% 0;
  }
}
@media only screen and (max-width: 1199px) {
  .table_content .app_header > *:last-child {
    padding-left: 0;
    padding-right: 0;
    padding-top: 20px;
    margin-top: 10px;
  }
}

.overlay {
  grid-template-columns: repeat(4, 1fr);
}
@media only screen and (max-width: 1199px) {
  .overlay {
    grid-template-columns: repeat(2, 1fr);
  }
}
.overlay > * {
  width: var(--width);
  height: var(--height);
}`, "",{"version":3,"sources":["webpack://./src/app/modules/home/components/applications/applications.component.scss"],"names":[],"mappings":"AAMA;EACE,MAAA;AALF;AAOE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,6BAAA;EACA,4BAAA;EACA,qBAAA;AALJ;AAfE;EAQA;IAeI,2BAAA;EAJJ;AACF;AAOE;EACE,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;AALJ;AAOI;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,iBAAA;AALN;;AAUA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;AAPF;AASE;EACE,YAAA;AAPJ;;AAWA;EACE,qCAAA;AARF;AAnDE;EA0DF;IAII,qCAAA;EAPF;AACF;AASE;EACE,oCAAA;EACA,6CAAA;AAPJ;AA5DE;EAiEA;IAKI,YAAA;EANJ;AACF;AASE;EACE,YAAA;AAPJ;AAWI;EACE,kBAAA;AATN;AAWM;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,iBAAA;AATR;AAlFE;EAkFI;IAYI,WAAA;IACA,WAAA;IACA,QAAA;IACA,SAAA;IACA,iBAAA;EARR;AACF;AA3FE;EA+EE;IAwBI,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,gBAAA;EARN;AACF;;AAaA;EACE,qCAAA;AAVF;AAvGE;EAgHF;IAII,qCAAA;EATF;AACF;AAWE;EACE,mBAAA;EACA,qBAAA;AATJ","sourcesContent":["@mixin md() {\r\n  @media only screen and (max-width: 1199px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n.table_header {\r\n  --i: 0;\r\n\r\n  &:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    z-index: -1;\r\n    width: var(--width);\r\n    top: 1px;\r\n    left: var(--left);\r\n    height: 100%;\r\n    border-radius: 8px;\r\n    opacity: 0.2;\r\n    background: var(--background);\r\n    transition: 0.3s ease-in-out;\r\n    filter: contrast(0.4);\r\n\r\n    @include md() {\r\n      height: calc(100% - 1.5rem);\r\n    }\r\n  }\r\n\r\n  .header {\r\n    margin-inline: 10px;\r\n    padding-inline: 10px;\r\n    padding-block: 0.2rem;\r\n    transition: 0.2s ease-in-out;\r\n\r\n    &:not(:first-child):after {\r\n      content: \"\";\r\n      display: block;\r\n      width: 2px;\r\n      height: 15px;\r\n      background-color: var(--surface-100);\r\n      position: absolute;\r\n      left: -10px;\r\n      top: 50%;\r\n      translate: 0 -50%;\r\n    }\r\n  }\r\n}\r\n\r\n.header_count {\r\n  width: 20px;\r\n  height: 20px;\r\n  font-size: 12px;\r\n  color: var(--surface-900);\r\n\r\n  .header:first-child & {\r\n    color: black;\r\n  }\r\n}\r\n\r\n.table_content {\r\n  grid-template-columns: repeat(4, 1fr);\r\n\r\n  @include md() {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n\r\n  .app {\r\n    border: 1px solid var(--surface-100);\r\n    box-shadow: 0px 0px 8px 1px var(--background);\r\n\r\n    @include md() {\r\n      height: 100%;\r\n    }\r\n  }\r\n\r\n  .image-container {\r\n    height: 32px;\r\n  }\r\n\r\n  .app_header {\r\n    > *:last-child {\r\n      padding-left: 10px;\r\n\r\n      &:before {\r\n        content: \"\";\r\n        display: block;\r\n        width: 2px;\r\n        height: 15px;\r\n        background-color: var(--surface-100);\r\n        position: absolute;\r\n        left: -10px;\r\n        top: 50%;\r\n        translate: 0 -50%;\r\n\r\n        @include md() {\r\n          width: 15px;\r\n          height: 2px;\r\n          top: 0px;\r\n          left: 50%;\r\n          translate: -50% 0;\r\n        }\r\n      }\r\n\r\n      @include md() {\r\n        padding-left: 0;\r\n        padding-right: 0;\r\n        padding-top: 20px;\r\n        margin-top: 10px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.overlay {\r\n  grid-template-columns: repeat(4, 1fr);\r\n\r\n  @include md() {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n\r\n  > * {\r\n    width: var(--width);\r\n    height: var(--height);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
